<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionAcademyUsersDropDownFilters"
  >
    <section
      v-if="showLoadingState"
      key="loadingState"
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li>
          <a
            href="#"
            @click.prevent=""
          >
            <AtomLoadingSecondary/>
          </a>
        </li>
      </ul>
    </section>
    <form
      v-else
      key="academyUsersDropDownFilters"
      autocomplete="off"
      name="UsersDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyUsersDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.habilitado"
                :elements="estados"
                key-field="id"
                name="habilitado"
                reference="habilitado"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyUsersDropDownFilters.input.actor.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.tipo"
                :elements="$filters.parameters.actors"
                key-field="id"
                name="actor"
                reference="actor"
                text-field="name"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyUsersDropDownFilters.input.nombre.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.nombre"
                class="a-input-primary"
                name="nombre"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyUsersDropDownFilters.input.email.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.email"
                class="a-input-primary"
                name="email"
                :placeholder="$t('mEditionAcademyUsersDropDownFilters.input.email.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyUsersDropDownFilters.input.fecha.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionAcademyUsersDropDownFilters.input.fecha.desde.placeholder')"
              />
              <span class="margin-bottom-xlarge"></span>
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionAcademyUsersDropDownFilters.input.fecha.hasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyUsersDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.pais"
                :elements="paisesSelect"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionAcademyUsersDropDownFilters.buttons.reload') }}
        </button>
        <button
          class="a-button-primary a-button-academy-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionAcademyUsersDropDownFilters.buttons.search') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyUsersDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      estados: [
        {
          id: '',
          nombre: 'Todos los Estados'
        },
        {
          id: 1,
          nombre: 'Habilitados'
        },
        {
          id: 2,
          nombre: 'Deshabilitados'
        }
      ],

      filter: {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        habilitado: '',
        limite: 10,
        nombre: '',
        pagina: 1,
        pais: '',
        tipo: ''
      },

      paises: [],
      showLoadingState: true,
      tipoActores: []
    }
  },

  computed: {
    paisesSelect () {
      let paises = [...this.paises]
      paises.unshift({
        id_pais: '',
        nombre: this.$t('mEditionAcademyUsersDropDownFilters.input.pais.firstOption')
      })
      return paises
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.email = this.filterSeted.email
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.habilitado = this.filterSeted.habilitado
        this.filter.nombre = this.filterSeted.nombre
        this.filter.pais = this.filterSeted.pais
        this.filter.tipo = this.filterSeted.tipo

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    this.tipoActores = [...this.$filters.parameters.actors]
    this.readParametroPaises()
  },

  methods: {
    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionAcademyUsersDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
